
//import { render } from '@testing-library/react';
import './Column.scss';
import Task from '../Task/Task';
import { Droppable } from '@hello-pangea/dnd';

const Column = (props) => {
  const {dispatch} = props;

// SET TaskList COMPONENT

  const TaskList = (props) => {

    const { provided, innerRef } = props;

    return (
      <div className='taskList' {...provided.droppableProps} ref={innerRef}>
        
        {props.tasks.map((task, index) => (
          <Task key={task.id} task={task} index={index} 
          styleAnswer={props.styleAnswer}
          isSelected={props.isSelected}
          />
          ))}

        {provided.placeholder}

      </div>
    )
};

  const Welcome = (props) => {
  return <div className='taskList'>{props.text}</div>
};

//RENDER TASKS
const renderTasks = () => {
  return (
    
      
    props.tasks.map(task => {
      
      return (
        
      <Task key={task.id} task={task} /> 
        
      )
          })
         

    
  )
}



    return (
      <div className="Column">
        <div className='container'>
          <p className='helper'>{props.sortQuestion ===3 ? null:'Перетаскивайте боксы в нужном порядке'}</p>
          <p className='helper'>{(props.sortQuestion ===3 && props.index ===1) ? 'Перетаскивайте необходимые боксы в свободное поле':null}</p>
          <Droppable droppableId={props.column.id}>
            {provided => 
              <TaskList tasks={props.tasks} innerRef={provided.innerRef}  
              provided={provided} 
              styleAnswer={props.styleAnswer}
              isSelected={props.isSelected}
              />
             }
          </Droppable>

        </div>
         
  
      </div>
    );




  }
  
  export default Column;